module.exports = __webpack_public_path__ + "img/tp8.ef65cebb.png";